import { ComponentChildren } from 'preact'
import classNames from 'classnames'

interface ControlSwitcherProps {
  className?: string
  'data-qa'?: string
}

const Switcher = ({ disable, on, onChange, label, meta, customClass = '', labelCustomClass = '', ControlSwitcherProps }: {
  disable?: boolean
  on?: boolean
  onChange: () => void
  label?: ComponentChildren
  meta?: string
  customClass?: string
  labelCustomClass?: string
  ControlSwitcherProps?: ControlSwitcherProps
}) => <label className={`${customClass} font-weight-normal preact-switch switcher${disable ? ' disable' : ''}`}>
  <div
    {...ControlSwitcherProps} className={classNames(ControlSwitcherProps?.className, 'control-switcher', { on: Boolean(on) })}
  >
    <a className='toggle' onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange() }} href='#'>
      <i className='icon-handler' />
    </a>
    <a className='ui-on' onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange() }} href='#'>
      <i className='icon-check-slim' />
    </a>
    <a className='ui-off' onClick={(e) => { e.preventDefault(); e.stopPropagation(); onChange() }} href='#'>
      <i className='icon-cross-slim' />
    </a>
  </div>
  <div className={`${labelCustomClass}`}>{label}</div>
  {meta && <div className='metadata'>{meta}</div>}
</label>

export default Switcher
